import { sendPendoEvent } from 'config/pendo';

// eslint-disable-next-line import/prefer-default-export
export const sendAnalyticsData = (eventName, options = null) => {
  sendPendoEvent(eventName, options);
};
